
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './components/portal/responsive-overrides.css';
import { loadRuntimeConfig } from './config/runtime';
import { SocketProvider } from './contexts/SocketContext';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Load runtime config first, then render app
loadRuntimeConfig().then(() => {
  root.render(
    <React.StrictMode>
      <SocketProvider>
        <App />
      </SocketProvider>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
